angular.module("Main").controller("TerminWartelisteBestaetigungController", ["$rootScope", "$scope", "$state", "$stateParams",
    "$localStorage", "$window", "$uibModal", "$translate", "BookingService",
    "PaymentService", "SessionService", "DialogService",
    function ($rootScope, $scope, $state, $stateParams, $localStorage, $window, $uibModal, $translate, BookingService,
              PaymentService, SessionService, DialogService) {
        var vm = this;

        vm.isApp = false;
        vm.isLoggedIn = false;
        vm.username = "";
        $localStorage.user = {};
        let uuid = false;
        let email = $stateParams.email;
        let password = $stateParams.pwd;
        let clubId = $stateParams.cid;
        if (!_.isUndefined($stateParams.id)) {
            uuid = $stateParams.id;
        }

        if (!_.isEmpty(email) && !_.isEmpty(password)) {
            AuthenticationService.login(email, password).then(function (response) {
                if (response === null) {
                    $state.go("no_access",{cid: 1, loginResponseNull: 1, loginError: 0, urlIncomplete: 0, main: 0});
                } else {
                    SessionService.setAuthData(clubId, uuid, true);
                    vm.isApp = true;
                    vm.isLoggedIn = true;
                }
            }).catch(function (error) {
                $state.go("no_access", {cid: 1, loginResponseNull: 0, loginError: 1, urlIncomplete: 0, main: 0, message: error.message});
            });
        }

        loadAppointmentInfos();
        loadConfigs();
        getKursbuchungLayouKonfiguration();
        loadLandingPageBSConfig();
        checkIfSixPaymentConfig();

        vm.imageUrl = BookingService.getAppointmentTypeImagePath();
        vm.accepted = false;
        vm.openedMenuBar = false;
        vm.showPayments = false;
        vm.choosenPaymentMethod = null;

        if (screen.width < 600) {
            vm.isMobilePhone = true;
            vm.weekView = true
        } else {
            vm.isMobilePhone = false;
            vm.weekView = true;
        }

        function loadAppointmentInfos() {
            BookingService.getAppointmentInfosForConfirmWaitlist($stateParams.appNr).then(function (data) {
                vm.meetingDate = {};
                vm.selectedPayment = "0";
                vm.meetingData = data;
                vm.meetingData.FreiePlaetze = true;
                vm.meetingData.Farbe = data.Ressourcenplaner_Terminart.Farbe;
                vm.backColor = data.Ressourcenplaner_Terminart.Farbe;
                vm.meetingData.Dauer = data.Ressourcenplaner_Terminart.TDauer;
                //vm.meetingData.Infotext = data.Ressourcenplaner_Terminart.Ressourcenplaner_OnlineKursbuchung_Terminarts[0].Infotext;
                vm.meetingData.Name = data.Ressourcenplaner_Terminart.Bezeichnung;
                vm.meetingData.PreisZahl = data.Ressourcenplaner_Terminart.PreisZahl;
                vm.meetingData.Bezahlung = data.Ressourcenplaner_Terminart.Buchungssystem_Terminarten.Bezahlung;
                //vm.meetingData.MitgliedsOptionKurse =  data.Ressourcenplaner_Terminart.Buchungssystem_Terminarten.MitgliedsOptionKurse;
                //vm.meetingData.Leistungsarten = data.
                vm.meetingData.IsSameDay = true;
                vm.meetingData.Tag = new Date(data.Start);
                vm.start = new Date (data.Start);
                vm.ende = new Date (data.Ende)
                vm.meetingData.Start = moment(data.Start).format('HH:mm').toString();
                vm.meetingData.Ende = moment(data.Ende).format('HH:mm').toString();
                vm.meetingData.AllRessources = [];
                _.forEach(data.Ressourcenplaner_JT_Termin_Ressources, function (ress) {
                    vm.meetingData.AllRessources.push({
                        Mitarbeiter: ress.Mitarbeiter,
                        Bezeichnung: ress.Ressourcenplaner_Ressource.Bezeichnung,
                        Id: ress.Ressourcenplaner_Ressource.Nr
                    })
                });
                let MitarbeiterRessource = _.sortBy(_.filter(vm.meetingData.AllRessources, {Mitarbeiter: 1}), 'Bezeichnung');
                let NichtMitarbeiterRessource = _.sortBy(_.filter(vm.meetingData.AllRessources, {Mitarbeiter: 0}), 'Bezeichnung');
                vm.ressourcesAll = _.concat(MitarbeiterRessource, NichtMitarbeiterRessource);
                vm.resourceNames = _.join(_.map(vm.ressourcesAll, "Bezeichnung"), ",");
                vm.ressourceIds = _.map(vm.meetingData.AllRessources, 'Id');
                vm.meetingDate.Day = data.Tag;
                vm.meetingDate.End = vm.meetingData.Ende;
                // if (vm.meetingData.Bezahlung < 1 || vm.meetingData.Bezahlung > 3)
                //     vm.meetingData.Bezahlung = 1;
            }).then(function () {
                BookingService.getImage(vm.meetingData.Terminart_Nr).then(function (data) {
                    vm.meetingData.Image = data;
                });
            }).then(function () {
                checkTerminartPayments();
                if (vm.isLoggedIn)
                    checkAfterLogin();
            })
        }

        function checkAfterLogin() {
            BookingService.checkAppointmentGroupLimit(vm.meetingData.Terminart_Nr,
                vm.currentUser.memberNr, vm.meetingDate.Day).then(function (limits) {
                if (limits && ((limits.day && limits.day.reached) || (limits.week && limits.week.reached) ||
                        (limits.month && limits.month.reached) || (limits.year && limits.year.reached))) {
                    vm.limits = limits;
                }
            }).catch(function () {
            });

            if (vm.meetingData.Ressourcenplaner_Terminart.Buchungssystem_Terminarten.Bezahlung === 3) {
                PaymentService.getArticlePrice(vm.currentUser.uid, vm.meetingData.Terminart_Nr, vm.meetingData.completeStart)
                    .then(function (priceData) {
                        if (!_.isEmpty(priceData))
                            vm.meetingData.PreisZahl = priceData.Price;
                    }).catch(function () {
                });
            }
        }

        var loginHandler = $rootScope.$on("login", function (event, data) {
            checkUser();
        });

        var logoutHandler = $rootScope.$on("logout", function () {
            SessionService.clear('globals', 'meetingData', 'meetingDate');
            $localStorage.user = {};
            unregisterEventHandler();
            $state.go('angebot', {cid: $stateParams.cid, id: $stateParams.id});
        });
        //
        // if (!SessionService.getSessionId()) {
        //     unregisterEventHandler();
        //     $state.go('angebot', {cid: $stateParams.cid, id: $stateParams.id});
        // } else
        //     start();
        //
        // function start() {
        //     vm.cookies = SessionService.checkSession();
        //     checkUser();
        //     init();
        // }



        function getKursbuchungLayouKonfiguration() {
            BookingService.getKursbuchungLayouKonfiguration().then(function (data) {
                vm.kursbuchungConfig = data;
            });
        }

        function loadLandingPageBSConfig() {
            BookingService.loadLandingPageBSConfig().then(function (data) {
                vm.landingPage = data;
                if (vm.landingPage.LandingPageBuchungssystem) {
                    if (window.location !== window.parent.location) {
                        if (_.startsWith(vm.landingPage.LandingPageUrlBuchungssystem, "http") || _.startsWith(vm.landingPage.LandingPageUrlBuchungssystem, "https")) {
                            vm.landingPageNewTabWithout = true;
                        } else {
                            vm.landingPageNewTabWith = true;
                        }

                        // The page is in an iframe
                    } else {
                        if (_.startsWith(vm.landingPage.LandingPageUrlBuchungssystem, "http") || _.startsWith("https", vm.landingPage.LandingPageUrlBuchungssystem, "https")) {
                            vm.landingPageWithout = true;
                        } else {
                            vm.landingPageWith = true;
                        }
                        // The page is not in an iframe
                    }
                }
            })
        }

        function checkIfSixPaymentConfig() {
            BookingService.checkSixConfig().then(function (data) {
                vm.isSixPayment = data.paymentValid;
            })
        }

        function checkTerminartPayments() {
            BookingService.checkPayments(vm.meetingData.Terminart_Nr).then(function (data) {
                vm.terminartPayments = data;
            })
        }

        $('#register-focus').autofocus;

        $scope.$on("destroy", function () {
            unregisterEventHandler();
        });

        function unregisterEventHandler() {
            loginHandler();
            logoutHandler();
        }

        function checkUser() {
            vm.isMember = $localStorage.user && $localStorage.user.username !== '' ? $localStorage.user.isMember : false;
            vm.isLoggedIn = !_.isNil($localStorage.user) && !_.isUndefined($localStorage.user.username);
            vm.currentUser = $localStorage.user;
            vm.isPayPal = $localStorage.user ? $localStorage.user.isPayPal : false;
            vm.isBonitaet = $localStorage.user ? $localStorage.user.isBonitaet : false;
            loadAppointmentInfos();
        }

        vm.booking = {};


        BookingService.loadConfigurationStammdaten().then(function (texts) {
            vm.stammdatenBestaetigung = texts.BestaetigungStammdaten;
            vm.stammdatenBestaetigung = texts.BestaetigungStammdaten;
            if (texts.TextObligatory) {
                vm.endTextFree = "T_Jetzt_verpflichtend_buchen";
                vm.endText = "T_Jetzt_kostenpflichtig_buchen";
            } else {
                vm.endTextFree = "T_Jetzt_Buchen";
                vm.endText = "T_Jetzt_Bezahlen";
            }
        });

        vm.bookAsLoggedIn = function () {
            if (vm.meetingData.PreisZahl > 0 && (vm.selectedPayment === "1" || vm.meetingData.Bezahlung === 2)) {
                bookSix();
            } else {
                bookWithoutPayment();
            }
        };

        vm.bookAsLoggedInVorOrt = function (method) {
            bookWithoutPayment(method);
        };

        function loadConfigs() {
            BookingService.loadLayoutConfiguration().then(function (data) {
                vm.layoutSettings = angular.fromJson(data.Layout);
                vm.privacytermsText = data.PrivacyPolicy;
            });
        }

        vm.openPrivacyTerms = function () {
            $uibModal.open({
                templateUrl: "app/Main/views/dialogs/privacyTerms.html",
                controller: "BookingPrivacyTermsDialogController",
                controllerAs: "vm",
                resolve: {style: vm.layoutSettings[3]}
            });
        };

        vm.loginModal = function () {
            var modalInstance = $uibModal.open({
                templateUrl: "app/Main/views/dialogs/login.html",
                controller: "LoginDialogController",
                controllerAs: "vm",
                backdrop: "static",
                keyboard: false
            });

            modalInstance.result.then(function (data) {
                if (!_.isNil(data)) {
                    $localStorage.user = {};
                    let now = new Date;
                    let hours = 6;
                    //let minutes = 5;
                    //let ttl = minutes * 60 * 1000
                    let ttl = hours * 60 * 60 *1000;
                    vm.isLoggedIn = true;
                    $localStorage.user.username = data.user.Firstname + " " + data.user.Lastname;
                    $localStorage.user.Firstname = data.user.Firstname;
                    $localStorage.user.Lastname = data.user.Lastname;
                    $localStorage.user.isMember = data.user.IsMember;
                    $localStorage.user.memberNr = data.user.MemberNr;
                    $localStorage.user.Email = data.user.Email;
                    $localStorage.user.uid = data.user.uid;
                    $localStorage.user.isPayPal = data.user.IsPaypal;
                    $localStorage.user.isBonitaet = data.user.IsBonitaet;
                    $localStorage.user.expiryTime = now.getTime() + ttl;
                    $rootScope.$emit("login", vm.isLoggedIn);
                }
            });
        };

        vm.registerModal = function () {
            SessionService.clear('globals');
            DialogService.openRegisterDialog().then(function () {
                init();
            }).catch(function () {
            });
        };

        function bookSix() {
            var tempBooking = {
                PersonNr: vm.currentUser.memberNr,
                TerminartNr: vm.meetingData.Ressourcenplaner_Terminart.Nr,
                RessourcenIds: vm.ressourceIds,
                Start: vm.start,
                Ende: vm.ende,
                TerminNr: $stateParams.appNr,
                Language: $translate.use(),
                ResourcesData: vm.meetingData.AllRessources,
                LinkId: $stateParams.id,
                OnlyBookInto: true
            };

            PaymentService.startPayment(tempBooking).then(function (url) {
                unregisterEventHandler();
                $window.location.href = url.redirectUrl;
            }).catch(function (reason) {
                if (reason.status === 410) {
                    vm.reservationError = true;
                } else if (reason.status === 400) {
                    vm.reserveError = true;
                    vm.reserveErrorText = reason.message;
                } else if (reason.status === 406) {
                    vm.paymentError = true;
                } else {
                    unregisterEventHandler();
                    $state.go("payment_error", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData()});
                }
            });
        }

        function bookWithoutPayment(method) {
            var tempBooking = {
                PersonNr: vm.currentUser.uid,
                TerminartNr: vm.meetingData.Ressourcenplaner_Terminart.Nr,
                RessourcenIds: vm.ressourceIds,
                Start: vm.start,
                Ende: vm.ende,
                TerminNr: $stateParams.appNr,
                Language: $translate.use(),
                ResourcesData: vm.meetingData.AllRessources,
                Zahlart: _.upperCase(method),
                OnlyBookInto: true,
                // Leistungsarten: vm.meetingData.Leistungsarten,
                // MitgliedsOption: vm.meetingData.MitgliedsOption
            }
            BookingService.createBooking(tempBooking).then(function (orderId) {
                unregisterEventHandler();
                $state.go('booking_success', {cid: SessionService.getAuthData(), locale: true, oid: orderId, id: SessionService.getAuthIdData()});
            }).catch(function (error) {
                if (error.status === 400) {
                    unregisterEventHandler();
                    $state.go("payment_member_already", {
                        cid: SessionService.getAuthData(),
                        id: SessionService.getAuthIdData(),
                        message: error.data.message,
                        isKurs: false
                    });
                }
                else if (error.status === 410) {
                    unregisterEventHandler();
                    vm.reservationError = true;
                } else {
                    vm.reserveError = true;
                    unregisterEventHandler();
                    $state.go("booking_termin_error", {cid: SessionService.getAuthData(), message: error, id: SessionService.getAuthIdData(), oid: $stateParams.oid});
                }

            })
        }

        vm.goToAngebot = function () {
            $state.go('angebot', {cid: $stateParams.cid, id: $stateParams.id});
            vm.openedMenuBar = false;
        };

        vm.openMenuBar = function () {
            if (vm.openedMenuBar === false) {
                vm.openedMenuBar = true;
            } else {
                vm.openedMenuBar = false;
            }
        };

        function bookPayPal() {
            var tempBooking = {
                PersonNr: vm.currentUser.uid,
                TerminartNr: vm.meetingData.Ressourcenplaner_Terminart.Nr,
                RessourcenIds: vm.ressourceIds,
                Start: vm.start,
                Ende: vm.ende,
                TerminNr: $stateParams.appNr,
                Language: $translate.use(),
                ResourcesData: vm.meetingData.AllRessources,
                LinkId: $stateParams.id,
                OnlyBookInto: true,
                // Leistungsarten: vm.meetingData.Leistungsarten,
                // MitgliedsOption: vm.meetingData.MitgliedsOption
            };
            PaymentService.startPaymentPayPal(tempBooking).then(function (url) {
                unregisterEventHandler();
                $window.location.href = url.redirectUrl;
            }).catch(function (reason) {
                if (reason.status === 500) {
                    unregisterEventHandler();
                    $state.go("payment_pp_error", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData(), oid: $stateParams.oid});
                } else {
                    if (reason.status === 410) {
                        vm.reservationError = true;
                    }
                    if (reason.status === 400) {
                        vm.reserveError = true;
                        vm.reserveErrorText = reason.message;
                    }
                    if (reason.status === 406) {
                        vm.paymentError = true;
                    }
                    $state.go("payment_pp_fail", {cid: SessionService.getAuthData(), id: SessionService.getAuthIdData(), oid: reason.data.oid});
                }
            })
        }

        vm.showPaymentMethods = function () {
            vm.showPayments = true;
        };

        vm.payNow = function (method) {
            if (method === 'pp') {
                bookPayPal();
            }
            if (method === 'six') {
                bookSix()
            }
            if (method === 'ls' || method === 'bar') {
                bookWithoutPayment(method);
            }
        }
    }]);